import mitt from "mitt";

const emitter = mitt();

// Provide Vue 2 compatible API for easier migration
const bus = {
  $on: emitter.on,
  $off: emitter.off,
  $emit: emitter.emit
};

export default bus;
